import store from "@/store";

export default function () {
  const t = store.getters["i18n/translate"];
  const locale = store.getters["i18n/locale"];

  return { t, locale };
}

